export default "/assets/images/purely-white.jpg?128d54a2d9c7a80f91889f2a824e7839";